export default __webpack_public_path__ + "static/media/ContractorsTab.9b853a7e.xlsx";